import React, { memo } from 'react'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import Dialog from '@material-ui/core/Dialog'
import Typography from '@material-ui/core/Typography'
import LOG from '../../logging/Logger'

export const ConfirmYesNoView = memo(
  ({ title, message, viewLabel = 'View', onYes, onNo, onView, open }) => {
    LOG.debug('Render: ConfirmYesNoView')

    return (
      <Dialog
        disableBackdropClick
        disableEscapeKeyDown
        maxWidth='xs'
        aria-label='confirmation-dialog'
        open={open}
      >
        <DialogTitle id='confirmation-dialog-title'>{title}</DialogTitle>
        <DialogContent dividers>
          <Typography>{message}</Typography>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={onYes} color='secondary'>
            Yes
          </Button>
          <Button onClick={onNo} color='primary'>
            No
          </Button>
          <Button onClick={onView} color='secondary'>
            {viewLabel}
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
)

ConfirmYesNoView.propTypes = {
  onYes: PropTypes.func.isRequired,
  onNo: PropTypes.func.isRequired,
  onView: PropTypes.func.isRequired
}

export default ConfirmYesNoView
